const body = document.querySelector('body'),
  siteNav = document.querySelector('.Header__Nav'),
  menuButton = document.querySelector('.Header__NavToggle'),
  menuActive = 'open',
  menuUnactive = 'closed'

export function menuOpen() {
  body.classList.add('nav-open')
  siteNav.setAttribute('aria-expanded', 'true')
  menuButton.setAttribute('aria-expanded', 'true')
}

export function menuClose() {
  body.classList.remove('nav-open')
  siteNav.removeAttribute('aria-expanded')
  menuButton.setAttribute('aria-expanded', 'false')
}

export default function menuInit() {
  // Click Main Menu Function
  function menuButtonClick(e) {
    e.preventDefault()
    if (siteNav.getAttribute('aria-expanded') == 'true') {
      menuClose()
    } else {
      menuOpen()
    }
  }
  if (menuButton) {
    menuButton.addEventListener('click', menuButtonClick)
  }
}
